import { render } from "./SolicitudesPage.vue?vue&type=template&id=3b6975f0&scoped=true"
import script from "./SolicitudesPage.vue?vue&type=script&lang=js"
export * from "./SolicitudesPage.vue?vue&type=script&lang=js"

import "./SolicitudesPage.vue?vue&type=style&index=0&id=3b6975f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b6975f0"]])

export default __exports__